import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardOrganizationEdit = guard(groupRights.Organizations)('edit')
export const guardOrganizationWatch = guard(groupRights.Organizations)('watch')
export const guardOrganizationCreate = guard(groupRights.Organizations)('create')

